/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Details/view.blocks to change it.
import PauseAction from './PauseAction/index'
import React from 'react'
import ResumeDate from './ResumeDate/index'



/** @type {import('Simple/types.js').View} */
export default function Details({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/DentalMonitoring/Content/Started/Pause/Details"
  
}) {
  return (<React.Fragment
>
<ResumeDate
  viewPath={`${viewPath}/ResumeDate`}
/>
<PauseAction
  viewPath={`${viewPath}/PauseAction`}
/>
{children}
</React.Fragment>)
}